import '../assets/css/Font.css';
import './Header.css';

const HeaderComp = () => {
  return(
    <div>
      <a href='/' className='home-btn' >
        <p className="font-header" >Idea de mis dedos</p>
      </a>
    </div>
  );
};

export default HeaderComp;